<div class="relative">
  <button
    type="button"
    (click)="toggleDropdown()"
    class="flex items-center gap-1.5 px-2 py-1.5 rounded-md border border-bb-border hover:bg-bb-bg-tertiary transition-colors text-bb-text-secondary hover:text-bb-text-primary"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="menu"
    aria-controls="language-dropdown">
    <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
      <path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <span class="text-xs font-mono uppercase tracking-wider">{{ currentConfig().nativeName }}</span>
    <svg class="w-3 h-3 text-bb-text-muted transition-transform"
         [class.rotate-180]="isOpen()"
         viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  @if (isOpen()) {
    <div
      id="language-dropdown"
      role="menu"
      class="absolute right-0 mt-1 w-56 rounded-lg border border-bb-border bg-bb-bg-secondary shadow-xl shadow-black/30 overflow-hidden z-dropdown">
      <div class="p-1">
        @for (lang of availableLanguages(); track lang.code) {
          <button
            type="button"
            role="menuitem"
            (click)="selectLanguage(lang.code)"
            class="w-full flex items-center justify-between px-3 py-2 rounded text-xs transition-colors"
            [class]="currentLanguage() === lang.code
              ? 'bg-bb-accent-blue/10 text-bb-accent-blue'
              : 'text-bb-text-secondary hover:text-bb-text-primary hover:bg-bb-bg-tertiary'">
            <span class="flex items-center gap-3">
              <span class="text-base">{{ getFlagEmoji(lang.code) }}</span>
              <span>
                <span class="block font-medium">{{ lang.nativeName }}</span>
                <span class="block text-2xs text-bb-text-muted">{{ lang.name }}</span>
              </span>
            </span>
            @if (currentLanguage() === lang.code) {
              <svg
                class="w-3.5 h-3.5 text-bb-accent-blue"
                viewBox="0 0 24 24"
                fill="none">
                <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            }
          </button>
        }
      </div>
    </div>
  }
</div>
